import {DropboxOutlined, LogoutOutlined, MenuFoldOutlined, MenuUnfoldOutlined, UsergroupAddOutlined} from '@ant-design/icons';
import {Avatar, Button, ConfigProvider, Divider, Form, Layout, Menu, theme} from 'antd';
import {Content, Header} from 'antd/es/layout/layout';
import Sider from 'antd/es/layout/Sider';
import {jwtDecode} from 'jwt-decode';
import React, {useEffect, useRef, useState} from 'react';
import {FaRupeeSign} from 'react-icons/fa';
import {MdOutlineDashboard, MdOutlineEvent, MdOutlineInventory, MdOutlineWork} from 'react-icons/md';
import {RiBillLine} from 'react-icons/ri';
import {useDispatch, useSelector} from 'react-redux';
import {NavLink, Route, Routes, useLocation, useNavigate} from 'react-router-dom';

import logo from '../../Assets/logo.jpeg';
import Collapselogo from '../../Assets/logo.jpeg';
import {RqEmployeeLookupById} from '../../reactQuery/apis/rqEmployeeAPI.js';
import {logoutStart} from '../../redux/authAction';

import AttendanceManagement from './AttendanceManagement/AttendanceManagement.js';
import BillingScreenTabs from './BillingScreenManagement/BillingScreenTabs.js';
import DrawerMenu from './DrawerMenu/DrawerMenu.js';
import EmployeeDetails from './EmployeeDetails/EmployeeDetails.js';
import InventoryScreen from './InventoryScreen/InventoryScreen.js';
import {MainDashboard} from './MainDashboard';
import ProductScreenTabs from './ProductScreens/ProductScreenTabs.js';
import ProfileScreen from './ProfileScreen/ProfileScreen.js';
import SalaryManagementScreen from './SalaryManagementScreen/SalaryManagementScreen.js';
import WorkFlow from './WorkFlow/WorkFlow.js';

function getItem(label, key, icon, path, children) {
  return {
    key,
    icon,
    label,
    path,
    children,
  };
}
const AdminDashboard =() => {
  const [collapsed, setCollapsed] = useState(false);

  const role = useSelector(state => state.auth?.user?.role);

  const {loggedIn} = useSelector(state => state.auth);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const location = useLocation();

  const today = new Date();

  const auth = useSelector(state => state.auth);
  const token = auth?.tokenData;

  let DecodedToken = null;

  let id = null;

  if (token) {
    try {
      DecodedToken = jwtDecode(token);
      id = DecodedToken?.userId;
    } catch {
      DecodedToken = null;
    }
  }
  
  const {data: profileDetails} = RqEmployeeLookupById(id, token, {
    enabled: loggedIn && !!id,
  });

  const adminItems = [
    getItem('Dashboard', '1', <MdOutlineDashboard className={'!text-[22px]'} />, '/admin/dashboard'),
    getItem('Inventory', '2', <MdOutlineInventory className={'!text-[22px]'} />, '/admin/inventory'),
    getItem('Product', '3', <DropboxOutlined className={'!text-[22px]'} />, '/admin/products'),
    getItem('Users', '4', <UsergroupAddOutlined className={'!text-[22px]'} />, '/admin/employee'),
    getItem('Bill', '5', <RiBillLine className={'!text-[22px]'} />, '/admin/bill'),
    getItem('Attendance', '6', <MdOutlineEvent className={'!text-[22px]'} />, '/admin/attendance'),
    getItem('Salary', '7', <FaRupeeSign className={'!text-[22px]'} />, '/admin/salary'),
    // getItem('Work Flow', '8', <MdOutlineWork className={'!text-[22px]'} />, '/admin/WorkFlow'),
  ];

  const accountantItems = [
    getItem('Dashboard', '1', <MdOutlineDashboard className={'!text-[22px]'} />, '/accountant/dashboard'),
    getItem('Inventory', '2', <MdOutlineInventory className={'!text-[22px]'} />, '/accountant/inventory'),
    getItem('Product', '3', <DropboxOutlined className={'!text-[22px]'} />, '/accountant/products'),
    getItem('Users', '4', <UsergroupAddOutlined className={'!text-[22px]'} />, '/accountant/employee'),
    getItem('Bill', '5', <RiBillLine className={'!text-[22px]'} />, '/accountant/bill'),
    getItem('Attendance', '6', <MdOutlineEvent className={'!text-[22px]'} />, '/accountant/attendance'),
    getItem('Salary', '7', <FaRupeeSign className={'!text-[22px]'} />, '/accountant/salary'),

  ];

  const supervisorItems = [
    getItem('Dashboard', '1', <MdOutlineDashboard className={'!text-[22px]'} />, '/supervisor/dashboard'),
    getItem('Inventory', '2', <MdOutlineInventory className={'!text-[22px]'} />, '/supervisor/inventory'),
    getItem('Product', '3', <DropboxOutlined className={'!text-[22px]'} />, '/supervisor/products'),
    getItem('Users', '4', <UsergroupAddOutlined className={'!text-[22px]'} />, '/supervisor/employee'),
    getItem('Bill', '5', <RiBillLine className={'!text-[22px]'} />, '/supervisor/bill'),
    getItem('Attendance', '5', <FaRupeeSign className={'!text-[22px]'} />, '/supervisor/attendance'),

  ];

  let items = [];

  if (role === 'ADMIN') {
    items = adminItems;
  } else if (role === 'ACCOUNTANT') {
    items = accountantItems;
  } else if (role === 'SUPERVISOR') {
    items = supervisorItems;
  }  const skipRedirectRef = useRef(false);

  useEffect(() => {
    if (!auth.loggedIn) {
      dispatch(logoutStart({showLoginModal: true}));
    }
  }, [auth.loggedIn, dispatch]);

  const day = today.toLocaleDateString('en-US', {weekday: 'long'});
  const date = today.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  const {
    token: {colorBgContainer, borderRadiusLG},
  } = theme.useToken();

  const handleLogout = () => {
    skipRedirectRef.current = true;
    dispatch(logoutStart());
    navigate('/');
  };
  const menuItems = items.map(item => ({
    key: item.path,
    icon: item.icon,
    label: (
      <p className={'w-full flex justify-start pl-3'}>
        {item.label}
      </p>
    ),
    className:'!text-primary-50 hover:!bg-primary-700 font-normal bg-primary-950 text-lg',
  }));

  return (
    <div>
      <Layout className={'h-full'}>
        <Sider width={'230'} trigger={null}
          className={'h-screen overflow-hidden lg:block hidden sticky top-0 left-0 bg-primary-950 text-white shadow-right shadow'}
          collapsible collapsed={collapsed}>
          <div className={'demo-logo-vertical'} />
          <div className={'flex items-center justify-center h-24 text-2xl my-2'}>
            {collapsed ? (
              <img
                src={Collapselogo}
                alt={'Logo'}
                className={ 'md:h-14 h-8'}
              />
            ) : (
              <img
                src={logo}
                alt={'Logo'}
                className={ 'md:h-24 h-8'}
              />
            )}
          </div>
          <Divider className={'my-4 bg-primary-700'} />
   
          <div className={'flex flex-col h-[calc(100vh-120px)] justify-between'}>
  
            {/* Menu items - top */}
            <Menu
              mode={'inline'}
              className={'bg-primary-950 mt-2'}
              selectedKeys={[location.pathname]}
              items={menuItems}
              onClick={({key}) => navigate(key)}
            />

            {/* Profile + Logout - bottom */}
            <div className={'border-t pb-2 border-primary-700 justify-center pt-0'}>
              <NavLink
                className={'w-full px-4 py-3 flex justify-center items-center gap-3'}
                to={
                  role === 'ADMIN'
                    ? '/admin/profile'
                    : role === 'ACCOUNTANT'
                      ? '/accountant/profile'
                      : '/supervisor/profile'
                }
              >
                <Avatar size={42} className={'bg-primary-50 shrink-0 text-primary-950 text-xl'}>
                  {profileDetails?.firstName?.[0]}
                </Avatar>

                {!collapsed && (
                  <div className={'text-left overflow-hidden'}>
                    <h4 className={'text-xl text-primary-50 font-semibold capitalize truncate m-0'}>
                      {profileDetails?.firstName} {profileDetails?.lastName}
                    </h4>
                    <p className={' text-primary-400 m-0 capitalize'}>{role?.toLowerCase()}</p>
                  </div>
                )}
              </NavLink>

              {/* Logout */}
              <Button
                onClick={handleLogout}
                className={
                  collapsed
                    ? 'flex items-center justify-center bg-transparent !border-none w-full hover:!bg-primary-950 hover:!text-primary-100 text-base text-primary-400 mb-4'
                    : 'flex items-center gap-2 bg-transparent !border-none w-full hover:!bg-primary-950 hover:!text-primary-100 text-lg text-primary-300 px-4 py-2 mb-4'
                }
              >
                <LogoutOutlined />
                {!collapsed && <span>Logout</span>}
              </Button>
            </div>

          </div>
        </Sider>

        <Layout className={'bg-white'}>
          <Header
            className={'sticky top-0 z-50 !bg-primary-50 flex items-center justify-between px-4  shadow-inner'}
            style={{background: colorBgContainer, height: 64}}
          >
            {/* Sidebar toggle button for desktop */}
            <Button
              type={'text'}
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              className={'text-xl lg:block hidden'}
            />
            {/* <div>
              <h1 className={'text-lg font-semibold text-primary-900'}>
    Welcome {profileDetails?.firstName}
              </h1>

              <p className={'text-sm text-primary-700 font-medium'}>
                (
                {role === 'ADMIN' && 'Admin'}
                {role === 'ACCOUNTANT' && 'Accountant Panel'}
                {role === 'SUPERVISOR' && 'Supervisor Panel'})
              </p>
            </div> */}

            {/* Drawer menu for mobile */}
            <div className={'lg:hidden block'}>
              <DrawerMenu items={items} />
            </div>

            {/* Welcome text */}
            <div className={'flex items-center gap-3'}>
              
              <div className={'text-center flex w-full  justify-between '}>
               
                <div className={'text-right'}>
                  <h1 className={'text-sm text-primary-900'}>{day}</h1>
                  <h1 className={'text-sm text-primary-900'}>{date}</h1>
                </div>
              </div>
             
            </div>
          </Header>
          
          <Content
            className={'!bg-white'}
            style={{
              margin: '24px 16px',
              padding: 24,
              minHeight: 280,
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
            }}
          >
            <ConfigProvider
              theme={{token: {colorPrimary: '#d4dadc'}}}
            >
              <Routes>

                {/* ADMIN */}
                {role === 'ADMIN' && (
                  <>
                    <Route path={'dashboard'} element={<MainDashboard />} />
                    <Route path={'employee'} element={<EmployeeDetails />} />
                    <Route path={'profile'} element={<ProfileScreen />} />
                    <Route path={'inventory'} element={<InventoryScreen />} />
                    <Route path={'products'} element={<ProductScreenTabs />} />
                    <Route path={'bill'} element={<BillingScreenTabs />} />
                    <Route path={'attendance'} element={<AttendanceManagement />} />
                    <Route path={'salary'} element={<SalaryManagementScreen />} />
                    {/* <Route path={'workFlow'} element={<WorkFlow />} /> */}
                  </>
                )}

                {/* ACCOUNTANT */}
                {role === 'ACCOUNTANT' && (
                  <>
                    <Route path={'dashboard'} element={<MainDashboard />} />
                    <Route path={'employee'} element={<EmployeeDetails />} />
                    <Route path={'profile'} element={<ProfileScreen />} />
                    <Route path={'inventory'} element={<InventoryScreen />} />
                    <Route path={'products'} element={<ProductScreenTabs />} />
                    <Route path={'bill'} element={<BillingScreenTabs />} />
                    <Route path={'attendance'} element={<AttendanceManagement />} />
                    <Route path={'salary'} element={<SalaryManagementScreen />} />
                  </>
                )}

                {/* SUPERVISOR */}
                {role === 'SUPERVISOR' && (
                  <>
                    <Route path={'dashboard'} element={<MainDashboard />} />
                    <Route path={'employee'} element={<EmployeeDetails />} />
                    <Route path={'profile'} element={<ProfileScreen />} />
                    <Route path={'inventory'} element={<InventoryScreen />} />
                    <Route path={'products'} element={<ProductScreenTabs />} />
                    <Route path={'bill'} element={<BillingScreenTabs />} />
                    <Route path={'attendance'} element={<AttendanceManagement />} />
                  </>
                )}

              </Routes>
            </ConfigProvider>

          </Content>
        </Layout>
      </Layout>
    
    </div>
  );
}; 

export default  AdminDashboard;
